import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

const cartStore = new Vuex.Store({
  state: {
    planArray: [],
    plan2dArray: [],
    //   onProcessUploadOrderArray:[],
    onProcessUploadOrder2dArray: [],
    //  onProcessShippingOrderArray:[],
    onProcessShippingOrder2dArray: [],
    // On Paying Process
    onProcessPayingOrder2dArray: [],
    totalPriceApproved: {
      sub_total_price: 0,
      tax: 0,
      total_price: 0,
      grand_total: 0,
    },
    couponCode: '',
    totalPriceWithCoupon: null,
    cartStatus: 1,
    paymentMethod: "bank_transfer",
    isModalCVS: false,
    isModalDescCVS: false,
    isModalDescCVSPayEasy: false,
    isModalNotesOnReg: false,
    selectedCVS: "",
    // Data Payment Info
    cvsCode: "",
    method: "",
    bkCode: "",
    custId: "",
    confNo: "",
    receiptNo: "",
    paymentLink: "",
    SMBCEnvKey: "",
  },
  mutations: {
    updatePaymentMethod(state, paymentMehod_) {
      state.paymentMethod = paymentMehod_;
      console.log(paymentMehod_);
    },
    setIsModalPaymentCVS(state, payload) {
      state.isModalCVS = payload;
    },
    setIsModalDescCVS(state, payload) {
      state.isModalDescCVS = payload;
    },
    setModalNotesOnReg(state, payload) {
      state.isModalNotesOnReg = payload;
    },
    setModalDescCvsPayEasy(state, payload) {
      state.isModalDescCVSPayEasy = payload;
    },
    setSelectedCVS(state, payoad) {
      state.selectedCVS = payoad;
      // console.log({ selectedCVS: state.selectedCVS })
    },
    updateTotalPriceApproved(state, val) {
      let x;

      val[0].active ? (x = val[0]) : (x = val[1]);
      state.totalPriceApproved = {
        sub_total_price:
          state.totalPriceApproved.sub_total_price + x.sub_total_price,
        tax: Math.floor(state.totalPriceApproved.tax + x.tax),
        total_price: Math.floor(
          state.totalPriceApproved.total_price + x.total_price
        ),
      };
    },
    updateTotalPriceApprovedOrikomi(state, val) {
      let x = val;

      state.totalPriceApproved = {
        sub_total_price:
          state.totalPriceApproved.sub_total_price + x.total_price,
        tax: Math.floor(state.totalPriceApproved.tax + x.tax),
        total_price: Math.floor(
          state.totalPriceApproved.total_price + x.total_price + x.tax
        ),
      };
    },
    updateTotalPriceApprovedGeenie(state, val) {
      let x = val;
      state.totalPriceApproved = {
        sub_total_price:
          state.totalPriceApproved.sub_total_price + x.sub_total_price,
        tax: Math.floor(state.totalPriceApproved.tax + x.tax),
        total_price: Math.floor(
          state.totalPriceApproved.total_price + x.sub_total_price + x.tax
        ),
      };
    },
    updateTotalPriceApprovedTicket(state, val) {
      let x = val;

      state.totalPriceApproved = {
        sub_total_price: state.totalPriceApproved.sub_total_price + x.sub_total,
        tax: Math.floor(state.totalPriceApproved.tax + x.tax),
        total_price: Math.floor(
          state.totalPriceApproved.total_price + x.sub_total + x.tax
        ),
      };
    },
    setCouponCode(state, val) {
      state.couponCode = val
    },
    setTotalWithCoupon(state, val) {
      state.totalPriceWithCoupon = val
    },
    resetTotalPriceApproved(state) {
      state.totalPriceApproved = {
        sub_total_price: 0,
        tax: 0,
        total_price: 0,
        grand_total: 0,
      };
      state.totalPriceWithCoupon = null
      state.couponCode = ''
    },
    updateTotalPriceWithPoint(state, val) {
      let total = state.totalPriceApproved.sub_total_price;
      let grand = state.totalPriceApproved.sub_total_price - Number(val);
      let tax = state.totalPriceApproved.tax;
      // let tax = Math.floor((10 * total) / 100);
      state.totalPriceApproved = {
        sub_total_price: state.totalPriceApproved.sub_total_price,
        tax,
        total_price: total + tax,
        grand_total: grand + tax,
      };
    },

    updateAllTotalPrice(state, val) {
      let sub_total =
        state.totalPriceApproved.sub_total_price - val.sub_total_price;
      let tax = state.totalPriceApproved.tax - val.tax;
      let total_price = state.totalPriceApproved.total_price - val.total_price;
      let grand = () => {
        if (val.points >= tax + sub_total) {
          return 0;
        } else {
          return total_price - val.points;
        }
      };
      state.totalPriceApproved = {
        sub_total_price: sub_total,
        tax,
        total_price: total_price,

        grand_total: grand(),
      };
    },
    updatePlanArray(state, planArray) {
      state.planArray = planArray;
    },
    updatePlan2dArray(state, plan2dArray) {
      state.plan2dArray = plan2dArray;
      console.log('updated DATA:',plan2dArray)
      if (state.plan2dArray === plan2dArray - 0) {
        console.log(plan2dArray, "updateArr");
      }
    },

    updateCartStatus(state, cartStatus) {
      state.cartStatus = cartStatus;
    },
    updateCartStatusWithHref(state, cartStatus) {
      //  state.cartStatus = cartStatus;
      location.href = "/cart?status=" + cartStatus;
    },
    /*     updateOnProcessUploadOrderArray(state,onProcessUploadOrderArray){
            state.onProcessUploadOrderArray = onProcessUploadOrderArray;
        },*/
    updateOnProcessUploadOrder2dArray(state, onProcessUploadOrder2dArray) {
      // state.onProcessUploadOrder2dArray = onProcessUploadOrder2dArray;
    },
    /*  updateOnProcessShippingOrderArray(state,onProcessShippingOrderArray){
            state.onProcessShippingOrderArray = onProcessShippingOrderArray;
        },*/
    updateOnProcessShippingOrder2dArray(state, onProcessShippingOrder2dArray) {
      // state.onProcessShippingOrder2dArray = onProcessShippingOrder2dArray;
    },
    // On Paying Process
    updateOnProcessPayingOrder2dArray(state, payload) {
      state.onProcessPayingOrder2dArray = payload;
    },

    // Setting Data Payment Info
    resetDataPaymentInfo(state) {
      state.cvsCode = "";
      state.bkCode = "";
      state.convenienceCode = "";
      state.accessId = "";
      state.accessPass = "";
      state.paymentLink = "";
      state.method = "";
    },
    setCvsCode(state, payload) {
      state.cvsCode = payload;
      // console.log(payload)
    },
    setMethod(state, payload) {
      state.method = payload;
    },
    setBkCode(state, payload) {
      state.bkCode = payload;
    },
    setCustId(state, payload) {
      state.custId = payload;
    },
    setConfNo(state, payload) {
      state.confNo = payload;
    },
    setReceiptNo(state, payload) {
      state.receiptNo = payload;
    },
    setPaymentLink(state, payload) {
      state.paymentLink = payload;
    },
  },
  getters: {
    cartCount: (state) => state.plan2dArray.length,
    activeCartCount(state) {
      let count = 0;
      for (let i = 0; i < state.plan2dArray.length; i++) {
        for (let j = 0; j < state.plan2dArray[i].length; j++) {
          if(Array.isArray(state.plan2dArray[i])) {
            for(let l = 0; l < state.plan2dArray[i][j].length; l++) {
              if (
                state.plan2dArray[i][j][l].extra?.authorized ||
                state.plan2dArray[i][j][l].authorized
              ) {
                count++;
              }
            }
          }
          if (
            state.plan2dArray[i][j].extra?.authorized ||
            state.plan2dArray[i][j].authorized
          ) {
            count++;
          }
        }
      }
      return count;
    },
    planArray: (state) => state.planArray,
    plan2dArray: (state) => state.plan2dArray,
    cartStatus: (state) => state.cartStatus,
    paymentMethod: (state) => state.paymentMethod,
    isModalCVS: (state) => state.isModalCVS,
    isModalDescCVS: (state) => state.isModalDescCVS,
    isModalNotesOnReg: (state) => state.isModalNotesOnReg,
    isModalDescCVSPayEasy: (state) => state.isModalDescCVSPayEasy,
    selectedCVS: (state) => state.selectedCVS,
    uploadCount: (state) => state.onProcessUploadOrder2dArray.length,
    shippingCount: (state) => state.onProcessShippingOrder2dArray.length,
    //onProcessUploadOrderArray: state => state.onProcessUploadOrderArray,
    onProcessUploadOrder2dArray: (state) => state.onProcessUploadOrder2dArray,
    //onProcessShippingOrderArray: state => state.onProcessShippingOrderArray,
    onProcessShippingOrder2dArray: (state) =>
      state.onProcessShippingOrder2dArray,
    // On Paying Process
    onProcessPayingOrder2dArray: (state) => state.onProcessPayingOrder2dArray,
    // PAYMENT
    cvsCode: (state) => state.cvsCode,
    method: (state) => state.method,
    bkCode: (state) => state.bkCode,
    custId: (state) => state.custId,
    confNo: (state) => state.confNo,
    receiptNo: (state) => state.receiptNo,
    paymentLink: (state) => state.paymentLink,
  },
  plugins: [createPersistedState()],
});

export { cartStore };
